export const PRICE_CURRENT = "USD 17";
export const PRICE_VALUE = 17;
export const PRICE_CURRENCY = "USD";

export const heroMockup =
  "https://cdn.magicpatterns.com/uploads/6cTJiA9A1M4H3KimKpdKzX/ChatGPT_Image_4_jul_2026,_01_07_31.png";

export interface Stat {
  value: string;
  label: string;
}

export const stats: Stat[] = [
  { value: "6", label: "Guías completas" },
  { value: "3", label: "Recursos extra" },
  { value: "+500", label: "Páginas" },
  { value: "100%", label: "Digital" },
];

export const heroMicrocopy =
  "Acceso digital inmediato · 6 tomos de estrategias prácticas · Más de 500 páginas · Pago único.";

export interface Problem {
  emoji: string;
  text: string;
}

export const problems: Problem[] = [
  { emoji: "🔁", text: "Repetís la misma consigna diez veces y seguís sin respuesta." },
  { emoji: "😮‍💨", text: "Cada mañana o cada tarea termina en la misma discusión." },
  { emoji: "🧩", text: "Una situación mínima cambia por completo el clima de la casa." },
  { emoji: "💭", text: "Recibís consejos distintos y terminás sin saber cuál aplicar." },
  { emoji: "📱", text: "Guardás videos e ideas sueltas, pero nada se convierte en un plan." },
  { emoji: "❤️", text: "Terminás el día con culpa, sintiendo que podrías haberlo hecho mejor." },
];

export interface Step {
  n: string;
  title: string;
  text: string;
}

export const steps: Step[] = [
  { n: "Paso 1", title: "Identificás", text: "¿Qué necesitás trabajar o comprender?" },
  { n: "Paso 2", title: "Consultás", text: "Abrís la guía relacionada con ese tema." },
  { n: "Paso 3", title: "Probás", text: "Elegís una estrategia o recurso como punto de partida." },
];

export const topicChips = [
  "Rutinas",
  "Atención",
  "Emociones",
  "Aprendizaje",
  "Comunicación",
  "Vínculo",
];

export interface Tomo {
  n: number;
  title: string;
  desc: string;
  img: string;
}

export const tomos: Tomo[] = [
  {
    n: 1,
    title: "Comprender sin culpas",
    desc: "El mapa para entender el TDAH y el autismo desde la práctica diaria, no desde el diagnóstico clínico.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/290fbdfe-5600-4231-a746-e29f0f647f6d.jpg",
  },
  {
    n: 2,
    title: "Rutinas que dan calma",
    desc: "Cómo estructurar el día para bajar la ansiedad y evitar las peleas por consignas simples.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/1deb8c03-5c81-491b-a22f-5d03774f0aad.jpg",
  },
  {
    n: 3,
    title: "Atención e impulsividad",
    desc: "Qué hacer cuando el “prestá atención” ya no alcanza, en el estudio y en la vida cotidiana.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/9addaa54-a07c-41c3-8b2c-9795443919d1.jpg",
  },
  {
    n: 4,
    title: "Regulación emocional",
    desc: "Herramientas tácticas para actuar antes, durante y después de un momento de crisis.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/b8bf037e-ba0f-4b7f-9f20-6e2ba190259d.jpg",
  },
  {
    n: 5,
    title: "Comunicación y lenguaje",
    desc: "Cómo conectar y hacerte entender cuando las palabras generan resistencia.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/1568c228-8f31-485b-92e8-8f91a6ff17a0.jpg",
  },
  {
    n: 6,
    title: "El adulto que acompaña",
    desc: "Estrategias de autocuidado y gestión para no agotarte en el proceso.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/2dbc2745-d26c-4e62-90fe-e08d9e207e74.jpg",
  },
];

export const educationalDisclaimer =
  "Material educativo e informativo. Parte de la colección aborda contenidos relacionados con TDAH y autismo. No sustituye evaluación, diagnóstico, tratamiento ni acompañamiento profesional.";

export interface Bonus {
  tag: string;
  title: string;
  desc: string;
  img: string;
}

export const bonuses: Bonus[] = [
  {
    tag: "Bono 01",
    title: "Guía de sobrecarga emocional",
    desc: "Para esos momentos en los que sentís que vas a explotar: qué hacer antes, durante y después.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/d028db2f-ca82-487b-b0f0-465750cc9904.jpg",
  },
  {
    tag: "Bono 02",
    title: "Mapa de funciones ejecutivas en casa",
    desc: "Estrategias tácticas para el orden, la organización y la conducta del día a día.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/c9babb2c-9b95-4962-9d84-abff2dd642d7.jpg",
  },
  {
    tag: "Bono 03",
    title: "Pictogramas y rutinas visuales",
    desc: "El poder de lo visual sobre lo hablado: tableros y secuencias listas para usar en casa.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/588348fe-07a0-45e0-b803-f901395e0fb7.jpg",
  },
];

export const offerIncludes = [
  "6 guías completas",
  "Más de 500 páginas",
  "3 recursos complementarios",
  "Material 100% digital",
  "Acceso inmediato",
  "Acceso de por vida",
];

export const previewChips = [
  "Guías",
  "Rutinas",
  "Actividades",
  "Ejemplos",
  "Tablas",
  "Recursos visuales",
];

export interface Preview {
  src: string;
  label: string;
}

/** Real interior pages from the product. */
export const previews: Preview[] = [
  {
    src: "https://cdn.magicpatterns.com/uploads/iy5em7H2scEhWDzZsTZth9/Captura_de_pantalla_2026-07-18_a_la(s)_12.33.56_a._m..png",
    label: "Estrategias que empiezan por comprender",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/2y6LQA7HSXJaZ58FHsucfR/Captura_de_pantalla_2026-07-18_a_la(s)_12.34.13_a._m..png",
    label: "Herramientas claras para mirar sin culpas",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/jw5wybgQrQjgNeB9U4Q2YN/Captura_de_pantalla_2026-07-18_a_la(s)_12.34.29_a._m..png",
    label: "Un plan con pasos reales para cada día",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/6xXNxZpcLQgGLMA99cJ4Xx/Captura_de_pantalla_2026-07-18_a_la(s)_12.31.06_a._m..png",
    label: "Cómo puede verse el TDAH en la vida diaria",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/dVsdYeMcpAtV8S2mSG35uK/Captura_de_pantalla_2026-07-18_a_la(s)_12.31.56_a._m..png",
    label: "Primeros pasos para acompañar mejor",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/5dCJb5Cumy3aVzmsyyh3MJ/Captura_de_pantalla_2026-07-18_a_la(s)_12.32.26_a._m..png",
    label: "Todo lo que encontrás en cada volumen",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/3BXHBtGyVmVu1CZEpxiXMf/Captura_de_pantalla_2026-07-18_a_la(s)_12.32.45_a._m..png",
    label: "Cómo funciona el cerebro en una crisis",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/k6kArH96UKQw7MjBUyDWuW/Captura_de_pantalla_2026-07-18_a_la(s)_12.33.06_a._m..png",
    label: "La conexión va antes que la corrección",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/nY1x7XKEK7VNvetywaqsGT/Captura_de_pantalla_2026-07-18_a_la(s)_12.33.21_a._m..png",
    label: "Cómo procesa la información un niño",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/w6LuFEp6Hwjaf9JLYUfQSn/Captura_de_pantalla_2026-07-18_a_la(s)_12.33.38_a._m..png",
    label: "Errores de comunicación que podés evitar",
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "¿Qué recibo con mi compra?",
    a: "Acceso digital a las 6 guías de Pequeños Pasos, Grandes Logros™ y a los 3 recursos complementarios incluidos en la oferta.",
  },
  {
    q: "¿El contenido aborda TDAH y autismo?",
    a: "Sí. Parte de la colección incluye contenido educativo relacionado con TDAH y autismo, además de temas como rutinas, atención, aprendizaje, regulación emocional, comunicación y acompañamiento cotidiano.",
  },
  {
    q: "¿Reemplaza una terapia o atención profesional?",
    a: "No. Es material educativo e informativo y no sustituye evaluación, diagnóstico, tratamiento ni acompañamiento profesional.",
  },
  {
    q: "¿Cómo recibo el material?",
    a: "Después de completar la compra se habilitan las instrucciones para acceder al contenido digital.",
  },
  {
    q: "¿Puedo verlo desde el celular?",
    a: "Sí. El contenido puede consultarse desde celular, tablet o computadora.",
  },
  {
    q: "¿Es una suscripción?",
    a: "No. Son USD 17 en un único pago.",
  },
];

export const trustBadges = [
  { icon: "lock", label: "Pago seguro" },
  { icon: "zap", label: "Acceso inmediato" },
  { icon: "shield", label: "Garantía de 7 días" },
];
